// Filet de dernier recours de l'écran : une page qui casse ne reste plus muette.
//
// POURQUOI CE COMPOSANT EXISTE
//
// Une exception React ne fait pas tomber le serveur : elle vide l'écran. Le
// client voit une page blanche, hausse les épaules, et ne dit rien — surtout
// un mécanicien pris par sa journée. La sonde extérieure, elle, interroge
// `/health`, qui répond parfaitement pendant que l'application est cassée.
//
// C'est le seul des trois volets de surveillance qui ne se voit ni du serveur
// ni de l'extérieur. Sans ce filet, on l'apprend par un appel du client —
// quand on l'apprend.
//
// DEUX CHOSES, ET DANS CET ORDRE
//
//   1. dire à l'utilisateur ce qui se passe et comment repartir. Une page
//      blanche laisse croire à une panne générale ; un message dit que le
//      reste marche ;
//   2. NOUS prévenir. L'envoi est silencieux et ne doit jamais empêcher
//      l'affichage du message — une panne dans le rapporteur de pannes
//      masquerait la panne d'origine.
import { Component } from "react";

import api from "../api";

export default class LimiteErreur extends Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null, signale: false };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, infos) {
    // UNE SEULE FOIS PAR ÉCRAN CASSÉ. React peut rappeler ce point à chaque
    // tentative de rendu : sans ce garde, un écran cassé enverrait des
    // dizaines de rapports pour un seul incident, et on apprendrait à les
    // ignorer.
    if (this.state.signale) return;
    this.setState({ signale: true });

    api
      .post("/erreurs-ecran", {
        message: String(erreur?.message || erreur).slice(0, 500),
        // La pile de composants dit QUEL écran a cassé — beaucoup plus utile
        // que la pile JavaScript, minifiée et illisible en production.
        composants: String(infos?.componentStack || "").slice(0, 2000),
        adresse: window.location.pathname,
      })
      .catch(() => {
        /* Silencieux : le message ci-dessous doit s'afficher quoi qu'il
           arrive. Si le serveur est injoignable, c'est lui le problème, et
           la sonde extérieure s'en charge. */
      });
  }

  render() {
    if (!this.state.erreur) return this.props.children;

    return (
      <div className="carte carte-etroite" style={{ margin: "40px auto" }}>
        <h2>Cet écran n'a pas pu s'afficher</h2>
        <p className="note-info">
          Le problème vient de l'application, pas de vos données — rien n'a été
          perdu. <strong>Il nous a été signalé automatiquement.</strong>
        </p>
        <div className="modal-actions">
          <button className="btn-accent" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
          <button className="btn" onClick={() => (window.location.href = "/")}>
            Retour au tableau de bord
          </button>
        </div>
      </div>
    );
  }
}
